/**
 * مشخصاتِ رخدادی که یک سیگنال از رویش ساخته شده — قرینه‌ی
 * apps/mobile/src/features/signals/EventDetails.tsx.
 *
 * ═══ چرا هست ═══
 *
 * وقتی کسی از صفحه‌ی کشف یک رخداد را برمی‌دارد و ازش دعوت می‌سازد، مکان و
 * آدرس و صفحه‌ی رسمی مالِ آن رخدادند و ستون‌های خودِ سیگنال خالی می‌مانند.
 * نتیجه‌اش یک صفحه‌ی سیگنال بود با فقط یک عنوان و یک «این آخرِ هفته» —
 * که روی یک دعوتِ واقعی («Light at Night Kayaking») دیده شد و درست هم
 * پرسیده شد: «پس اطلاعاتش کو؟»
 *
 * یک کامپوننت برای هر سه جایی که سیگنالِ کامل نشان داده می‌شود (صفحه‌ی
 * سیگنال، لینکِ عمومی، لینکِ شخصی) — چون سه نسخه یعنی روزی یکی‌شان آدرس
 * را جا می‌اندازد.
 *
 * بازه‌ی خودِ رخداد عمداً این‌جا نیست: «کِی؟» را میزبان انتخاب کرده و بالای
 * همین کارت نوشته شده. آن کایاکینگ چهار ماه برقرار است؛ نشاندنِ بازه‌ی
 * چهارماهه کنارش فقط همان یک جوابِ روشن را مبهم می‌کند.
 *
 * `hidePlace` برای صفحه‌های مهمان است: آن‌جا مکان ردیفِ برچسب‌دارِ خودش را
 * دارد (`guestView().facts`)، که هم `place_name` را می‌پوشاند هم مکانِ رخداد
 * را. بدونِ این پرچم همان آدرس دو بار پشتِ سرِ هم نوشته می‌شد.
 */
import React from 'react';
import type { SignalEvent } from '@/core/domain/types';
import { t } from '@/core/lib/i18n';
import { withUtm } from '@/core/lib/outboundUrl';
import { SafeImg } from '@/ui/SafeImg';

export function EventDetails({ event, hidePlace }: {
  event?: SignalEvent | null;
  hidePlace?: boolean;
}) {
  if (!event) return null;

  // اسمِ محل و آدرس یک خطند، نه دو تا: «Rideau Canal» بدونِ آدرس بی‌فایده‌ست
  // و آدرس بدونِ اسم بی‌روح. هر کدام که نبود، جداکننده هم نباید بیاید.
  const place = [event.venue, event.address].filter(Boolean).join(' · ');

  return (
    <>
      {event.imageUrl ? (
        <SafeImg className="signal-event-photo" src={event.imageUrl} loading="lazy"
          screen="web.signal" />
      ) : null}
      {place && !hidePlace ? <p>{place}</p> : null}
      {event.url ? (
        <p><a href={withUtm(event.url)} target="_blank" rel="noreferrer">{t('placeSource')}</a></p>
      ) : null}
    </>
  );
}
